export type SvgImportIssueCode =
  | "parse-error"
  | "unsupported-element"
  | "unsupported-attribute"
  | "approximated-path-command"
  | "approximated-geometry"
  | "missing-font"
  | "fallback-font"
  | "unsupported-gradient"
  | "unsupported-filter"
  | "unsupported-use"
  | "unsupported-image"
  | "missing-reference"
  | "ignored-defs";

export interface SvgImportIssue {
  code: SvgImportIssueCode;
  message: string;
  element?: string;
}

export class SvgImportIssueCollector {
  readonly issues: SvgImportIssue[] = [];

  add(issue: SvgImportIssue): void {
    this.issues.push(issue);
  }

  addOnce(code: SvgImportIssueCode, message: string, element?: string): void {
    if (!this.issues.some(existing => existing.code === code && existing.message === message && existing.element === element)) {
      this.add({ code, message, element });
    }
  }
}
